/* LUVIAN — carrito lateral y página /cart (vanilla JS) */
(function () {
  'use strict';
  if (window.mtCarrito) return;

  var raiz = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
  var ultimoFoco = null;
  var ocupado = false;

  function drawer() { return document.querySelector('[data-mtc-drawer]'); }

  /* Ids de las secciones de carrito presentes + el icono del header */
  function secciones() {
    var ids = [];
    document.querySelectorAll('[data-mtc-seccion]').forEach(function (el) {
      ids.push(el.getAttribute('data-mtc-seccion'));
    });
    if (document.getElementById('cart-icon-bubble')) ids.push('cart-icon-bubble');
    return ids;
  }

  /* Sustituye el contenido de cada sección con el HTML devuelto por Shopify */
  function pintar(sections) {
    if (!sections) return;
    var parser = new DOMParser();
    document.querySelectorAll('[data-mtc-seccion]').forEach(function (el) {
      var html = sections[el.getAttribute('data-mtc-seccion')];
      if (!html) return;
      var nuevo = parser.parseFromString(html, 'text/html').querySelector('[data-mtc-inner]');
      var viejo = el.querySelector('[data-mtc-inner]');
      if (!nuevo || !viejo) return;
      var cuerpo = viejo.querySelector('.mtc-cuerpo');
      var scroll = cuerpo ? cuerpo.scrollTop : 0;
      viejo.innerHTML = nuevo.innerHTML;
      var cuerpoNuevo = viejo.querySelector('.mtc-cuerpo');
      if (cuerpoNuevo) cuerpoNuevo.scrollTop = scroll;
    });
    var burbuja = document.getElementById('cart-icon-bubble');
    if (burbuja && sections['cart-icon-bubble']) {
      var sec = parser.parseFromString(sections['cart-icon-bubble'], 'text/html').querySelector('.shopify-section');
      if (sec) burbuja.innerHTML = sec.innerHTML;
    }
  }

  function refrescar() {
    var ids = secciones();
    if (!ids.length) return Promise.resolve();
    return fetch(window.location.pathname + '?sections=' + ids.join(','), { credentials: 'same-origin' })
      .then(function (r) { return r.json(); })
      .then(pintar)
      .catch(function () {});
  }

  /* ---- Abrir / cerrar ---- */
  function abrir() {
    var d = drawer();
    if (!d) { window.location.href = raiz + 'cart'; return; }
    ultimoFoco = document.activeElement;
    d.classList.add('is-abierto');
    d.setAttribute('aria-hidden', 'false');
    document.documentElement.classList.add('mtc-bloqueo');
    var panel = d.querySelector('.mtc-panel');
    setTimeout(function () { if (panel) panel.focus({ preventScroll: true }); }, 50);
  }
  function cerrar() {
    var d = drawer();
    if (!d || !d.classList.contains('is-abierto')) return;
    d.classList.remove('is-abierto');
    d.setAttribute('aria-hidden', 'true');
    document.documentElement.classList.remove('mtc-bloqueo');
    if (ultimoFoco && ultimoFoco.focus) ultimoFoco.focus({ preventScroll: true });
  }

  function aviso(texto) {
    var t = document.createElement('div');
    t.className = 'mtc-toast';
    t.setAttribute('role', 'alert');
    t.textContent = texto;
    document.body.appendChild(t);
    requestAnimationFrame(function () { t.classList.add('is-visible'); });
    setTimeout(function () { t.classList.remove('is-visible'); setTimeout(function () { t.remove(); }, 400); }, 3500);
  }

  function marcarCargando(on) {
    document.querySelectorAll('.mtc').forEach(function (el) { el.classList.toggle('is-cargando', on); });
  }

  /* ---- Añadir al carrito (cualquier formulario de producto) ---- */
  document.addEventListener('submit', function (e) {
    var form = e.target;
    var accion = form && form.getAttribute ? form.getAttribute('action') || '' : '';
    if (accion.indexOf('/cart/add') === -1) return;
    if (form.closest('[data-mtc-ignorar]')) return;
    e.preventDefault();
    e.stopImmediatePropagation();

    var boton = form.querySelector('[type="submit"]');
    if (boton && (boton.disabled || boton.classList.contains('is-cargando'))) return;
    if (boton) boton.classList.add('is-cargando');

    var datos = new FormData(form);
    var d = drawer();
    var directo = d && d.getAttribute('data-al-anadir') === 'pago';
    if (!directo) {
      datos.append('sections', secciones().join(','));
      datos.append('sections_url', window.location.pathname);
    }

    fetch(raiz + 'cart/add.js', {
      method: 'POST',
      credentials: 'same-origin',
      headers: { 'X-Requested-With': 'XMLHttpRequest', Accept: 'application/json' },
      body: datos
    })
      .then(function (r) { return r.json().then(function (j) { return { ok: r.ok, j: j }; }); })
      .then(function (res) {
        if (!res.ok) {
          if (boton) boton.classList.remove('is-cargando');
          aviso(res.j.description || res.j.message || 'No se pudo añadir. Inténtalo de nuevo.');
          return;
        }
        if (directo) { window.location.href = raiz + 'checkout'; return; }
        if (boton) boton.classList.remove('is-cargando');
        pintar(res.j.sections);
        if (document.querySelector('[data-mtc-pagina]')) return;
        abrir();
        var key = res.j.key || (res.j.items && res.j.items[0] && res.j.items[0].key);
        if (key) {
          var li = document.querySelector('.mtc-drawer [data-mtc-key="' + key + '"]');
          if (li) li.classList.add('is-nuevo');
        }
      })
      .catch(function () {
        if (boton) boton.classList.remove('is-cargando');
        form.submit();
      });
  }, true);

  /* ---- Cambiar cantidades / quitar ---- */
  function cambiar(key, cantidad) {
    if (ocupado) return;
    ocupado = true;
    marcarCargando(true);
    fetch(raiz + 'cart/change.js', {
      method: 'POST',
      credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ id: key, quantity: cantidad, sections: secciones(), sections_url: window.location.pathname })
    })
      .then(function (r) { return r.json().then(function (j) { return { ok: r.ok, j: j }; }); })
      .then(function (res) {
        if (!res.ok) { aviso(res.j.description || res.j.message || 'No se pudo actualizar el carrito.'); return refrescar(); }
        pintar(res.j.sections);
      })
      .catch(function () { return refrescar(); })
      .then(function () { ocupado = false; marcarCargando(false); });
  }

  document.addEventListener('click', function (e) {
    var t = e.target.closest ? e.target : null;
    if (!t) return;

    var btnCambiar = t.closest('[data-mtc-cambiar]');
    if (btnCambiar) {
      e.preventDefault();
      var li = btnCambiar.closest('.mtc-item');
      var cant = Math.max(0, parseInt(btnCambiar.getAttribute('data-cantidad'), 10) || 0);
      if (cant === 0 && li) li.classList.add('is-saliendo');
      cambiar(btnCambiar.getAttribute('data-mtc-cambiar'), cant);
      return;
    }

    if (t.closest('[data-mtc-cerrar]')) { e.preventDefault(); cerrar(); return; }

    var pagar = t.closest('[data-mtc-pagar]');
    if (pagar) { pagar.classList.add('is-cargando'); return; }

    /* Icono del carrito del header: abre el panel en vez de ir a /cart */
    var icono = t.closest('#cart-icon-bubble');
    if (icono && drawer() && !document.querySelector('[data-mtc-pagina]')) {
      e.preventDefault();
      abrir();
      refrescar();
    }
  });

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') cerrar();
  });

  /* Al volver atrás desde el pago, el carrito puede haber cambiado */
  window.addEventListener('pageshow', function (e) {
    document.querySelectorAll('[data-mtc-pagar].is-cargando').forEach(function (b) { b.classList.remove('is-cargando'); });
    if (e.persisted) refrescar();
  });

  /* Editor de Shopify: mostrar el panel al seleccionar la sección */
  document.addEventListener('shopify:section:select', function (e) {
    if (e.target && e.target.querySelector && e.target.querySelector('[data-mtc-drawer]')) abrir();
  });
  document.addEventListener('shopify:section:deselect', function (e) {
    if (e.target && e.target.querySelector && e.target.querySelector('[data-mtc-drawer]')) cerrar();
  });

  window.mtCarrito = { abrir: abrir, cerrar: cerrar, refrescar: refrescar };
})();
